import React, { useContext } from 'react'
import PermanenceReportContext from '../../../context/PermanenceReportContext/PermanenceReportContext';
import { CustomTable } from '../../CustomTable/CustomTable';
import PermanenceTableList from './PermanenceTableList';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import { t } from 'i18next';
import { getTenantInfoByKey } from '../../../helpers/helpers';

const PermanenceTable = () => {

    const { permanenceReportState, getPermanenceReport } = useContext(PermanenceReportContext);

    const { headers, reports, reportFilter } = permanenceReportState;

    const formatedHeaders = headers.map(header => ({
        ...header,
        key: header.key === ('TYPE_CONTRACT') ? getTenantInfoByKey('hiring_modalities_name') : t(header.key)
    }));

    const handleOrderColumn = (columnName) => {
        const currentHeader = headers.find(header => header.columnOrder === columnName);
        getPermanenceReport({
            ...reportFilter,
            column_order: columnName,
            order_type: currentHeader.order === 'ASC' ? 'DESC' : 'ASC',
        })
    }

    return (
        <div>
            {
                reports.length === 0 ?
                    <EmptyStateOne message={t('NO_DATA_SEARCH')} />
                    :
                    <CustomTable headers={formatedHeaders} onClickSort={handleOrderColumn}>
                        {reports.map((report, idx) =>
                            <PermanenceTableList
                                key={idx}
                                report={report}
                            />
                        )}
                    </CustomTable>
            }
        </div>
    )
}

export default PermanenceTable